import { Controller } from '@hotwired/stimulus';
import Toast from 'bootstrap/js/dist/toast';

/**
 * Toasts beyond the stack limit are rendered inside a <template>. The "+N more"
 * button (above the stack) reveals them below the visible toasts.
 */
export default class ToastStackController extends Controller {
  declare private readonly overflowTarget: HTMLTemplateElement;
  declare private readonly moreTarget: HTMLElement;
  declare private readonly hasOverflowTarget: boolean;

  public static readonly targets = ['overflow', 'more'];

  public expand(): void {
    if (!this.hasOverflowTarget) {
      return;
    }

    const revealed = Array.from(
      this.overflowTarget.content.cloneNode(true).childNodes
    );

    this.moreTarget.remove();
    this.element.append(...revealed);
    this.overflowTarget.remove();

    revealed
      .filter((node): node is HTMLElement => node instanceof HTMLElement)
      .filter(node => node.classList.contains('toast'))
      .forEach(toast => Toast.getOrCreateInstance(toast).show());
  }
}
